import React, { Component } from 'react';

import Activation from './components/Activation.js'
import ManualActivation from './components/ManualActivation.js'
import Account from './components/Account.js'
import Auth from './components/Auth.js'
import InstagramEmail from './components/InstagramEmail.js'
import Home from './components/Home'

import './App.css';

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Image from 'react-bootstrap/lib/Image';

import { updateAccount, checkAccountStatus } from './actions/auth.js'
import { showLoginModal, closeLoginModal } from './actions/login.js'
import { showActivationModal, closeActivationModal } from './actions/activation.js'
import { showManualActivationModal, closeManualActivationModal } from './actions/manualActivation.js'
import { showAccountModal, closeAccountModal, fetchAccountDetails } from './actions/account.js'

var Navbar = require('react-bootstrap').Navbar;
var Nav = require('react-bootstrap').Nav;
var NavItem = require('react-bootstrap').NavItem;
var NavDropdown = require('react-bootstrap').NavDropdown;
var MenuItem = require('react-bootstrap').MenuItem;
var Link = require('react-bootstrap').Link;

class App extends Component {

	showLoginModal() {
		this.props.history.push("/Home/")
		const { dispatch } = this.props

    localStorage.removeItem("didDisplayApprovalScreen")
    localStorage.removeItem("didDisplayManualApprovalScreen")
    localStorage.removeItem("status")

    dispatch(updateAccount({}))
		dispatch(showLoginModal())
	}

	componentDidMount() {
		this.fetchAccountInfo()
	}

	componentDidUpdate() {
		this.checkAccountState()
	}

	async fetchAccountInfo() {
		const { dispatch } = this.props
		let account = this.props.account

		if (account) {
			dispatch(checkAccountStatus(account._id))
		}
	}

	checkAccountState() {
		const { dispatch } = this.props
		let account = this.props.account

		if (account) {
			let status = account.status
			let localStatus = localStorage.getItem("status")
			let providedRequestedInfo = account.providedRequestedInfo

			let didDisplayApprovalScreen = localStorage.getItem("didDisplayApprovalScreen")
			let didDisplayManualApprovalScreen = localStorage.getItem("didDisplayManualApprovalScreen")

			if ((status === "requiresActivation" && didDisplayApprovalScreen === "true") ||
				(status === "requiresManualActivation" && (didDisplayManualApprovalScreen === "true" || providedRequestedInfo == "true"))) {

				dispatch(showAccountModal())

				// request account status to verify if account was activated
				this.fetchAccountInfo()

			} else if (status === "requiresActivation") {
				localStorage.setItem("didDisplayApprovalScreen", true)

				dispatch(closeLoginModal())
				dispatch(showActivationModal())
			} else if (status === "requiresManualActivation") {

				if (account.providedRequestedInfo) {
					dispatch(showAccountModal())
					this.fetchAccountInfo()
				} else {

					localStorage.removeItem('didDisplayManualApprovalScreen')
					dispatch(closeLoginModal())
					dispatch(showManualActivationModal())
				}
			} else if (
				status === "active" && status !== localStatus) {
				dispatch(closeLoginModal())
				dispatch(closeManualActivationModal())
				dispatch(closeActivationModal())
				dispatch(closeAccountModal())
				localStorage.setItem("didDisplayApprovalScreen", false)
				localStorage.setItem("didDisplayManualApprovalScreen", false)
			}

			localStorage.setItem("status", status)
		}
	}

	showAccount() {
		const { dispatch } = this.props
		let account = this.props.account

		dispatch(showAccountModal())
		dispatch(fetchAccountDetails(account._id))
	}

	render() {
		return (
			<div>

				<Navbar>
					<Navbar.Header >
						<Navbar.Brand style={{ paddingTop: '10px' }}>
							<a href="/Home/"  ><img src="//static1.squarespace.com/static/58b89bb729687fbe30a161a0/t/5ace6b72575d1f707e5ee672/1537850540652" alt="Better Spaces" style={{ width: "auto", height: "25px", paddingBottom: '5px' }}></img></a>
						</Navbar.Brand>
						<Navbar.Toggle />
					</Navbar.Header>
					<Navbar.Collapse>
						{this.props.account && (this.props.location.pathname !== '/Home/' && this.props.location.pathname !== '/Home')  ?
							(<Nav pullLeft>
								<NavDropdown title="DO">
									<MenuItem componentClass={Link} href="/events/upcoming" to={"/events/upcoming"}>Upcoming Events</MenuItem>
									<MenuItem componentClass={Link} href="/events/past" to={"/events/past"}>Past Events</MenuItem>
								</NavDropdown>

								<NavDropdown title="BOOK">
									<MenuItem componentClass={Link} href="/locations/bookings" to={"/locations/bookings"}>Locations</MenuItem>
									<MenuItem componentClass={Link} href="/locations/my_bookings" to={"/locations/my_bookings"}>My Booking</MenuItem>
								</NavDropdown>

								<MenuItem componentClass={Link} href="/BuildingControls/" to={"/BuildingControls/"}>CONTROLS</MenuItem>

								<MenuItem componentClass={Link} href="/BuildingDetails/" to={"/BuildingDetails/"}>DETAILS</MenuItem>


							</Nav>) : (<Nav></Nav>)}

						<Nav pullRight>
							{this.props.account ?
								(<NavItem
									eventKey={1}
									href="#"
									onSelect={this.showAccount.bind(this)}>
									{
										this.props.account.image ?
										<Image src={this.props.account.image} onError={(e) =>  e.target.src="/images/guestAvatar.png"}
											   circle thumbnail className="navbar-profile-picture" />
										:
										<Image src='/images/guestAvatar.png' circle thumbnails className="navbar-profile-picture" />
									}
								</NavItem>) :
								(<NavItem
									eventKey={2}
									href="#"
									onSelect={this.showLoginModal.bind(this)}>
									Login
			    </NavItem>)}
						</Nav>
					</Navbar.Collapse>
				</Navbar>
				<Auth />
				{/* <Route exact path="/login" component={Login} /> */}
				<Activation />
				<ManualActivation />
				<Account />
				<InstagramEmail />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		account: state.authReducer.account
	}
}

export default withRouter(
	connect(mapStateToProps)(App)
);



// WEBPACK FOOTER //
// ./src/App.js